// Small React components shared across EI panels.
// Depend on constants + format helpers — never imported by them.

import React from "react";
import { ACCOMMODATION_COLORS, SOURCE_COLORS, SOURCE_LABELS } from "./constants";
import { scoreTierColor } from "./format";

const SCORE_BADGE_SIZE_CLASSES = {
  sm: "w-8 h-8 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-12 h-12 text-base",
};

export const ScoreBadge = ({ score, size = "md" }) => {
  const color = scoreTierColor(score);
  const sizeCls = SCORE_BADGE_SIZE_CLASSES[size] ?? SCORE_BADGE_SIZE_CLASSES.md;
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full text-white font-bold shrink-0 ${sizeCls}`}
      style={{ backgroundColor: color }}
      title={`Score ${score}`}
    >
      {score}
    </div>
  );
};

const formatAccommodation = (type) => {
  if (!type) return "";
  const lower = String(type).toLowerCase();
  if (lower === "rv") return "RV";
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

export const AccommodationPill = ({ type, prefix, fallback = null }) => {
  if (!type) return fallback;
  const cfg = ACCOMMODATION_COLORS[type] ?? { bg: "bg-gray-100 dark:bg-gray-800", text: "text-gray-600 dark:text-gray-300" };
  const label = formatAccommodation(type);
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${cfg.bg} ${cfg.text}`}>
      {prefix ? `${prefix}: ${label}` : label}
    </span>
  );
};

export const SourceDot = ({ source, showLabel = false }) => {
  const color = SOURCE_COLORS[source];
  if (!color) return null;
  const label = SOURCE_LABELS[source] || source;
  if (showLabel) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400" title={label}>
        <span className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
        {label}
      </span>
    );
  }
  return (
    <span
      className="inline-block w-2 h-2 rounded-full"
      style={{ backgroundColor: color }}
      title={label}
    />
  );
};
